import React from "react";

export function isObject(value) {
    return typeof value === 'object' && value !== null;
}
export function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}

export const sortObjectByKey = (object, descending = false) => {
    const unsortedObjArr = [ ...Object.entries(object) ];

    var sortedObjArr = unsortedObjArr.sort(
        ([key1, value1], [key2, value2]) => {
            return (descending)
                ? key2.localeCompare(key1)
                : key1.localeCompare(key2);
        }
    );

    const sortedObj = {};
    sortedObjArr.forEach(([key, value]) => (sortedObj[key] = value));
    return sortedObj;
}

/**
 * Sorts an object by the value of a particular field
 * @param object
 * @param fieldName
 * @param descending
 * @returns {{}}
 */
export const sortObjectByField = (object, fieldName, descending = false) => {
    const unsortedObjArr = [ ...Object.entries(object) ];

    var sortedObjArr = unsortedObjArr.sort(
        ([key1, value1], [key2, value2]) => {
            return (descending)
                ? value2[fieldName].localeCompare(value1[fieldName])
                : value1[fieldName].localeCompare(value2[fieldName]);
        }
    );

    const sortedObj = {};
    sortedObjArr.forEach(([key, value]) => (sortedObj[key] = value));
    return sortedObj;
}

export const isObjectEmpty = (obj) => {
    return !objectIsNotEmpty;
}

export const objectIsNotEmpty = (obj) => {
    function isNotEmpty(value) {
        if (typeof value === 'undefined' || value === null) {
            return false;
        }

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return true;
        }

        if (Array.isArray(value)) {
            return value.length > 0;
        }

        if (typeof value === 'object') {
            return hasNonEmptyProperties(value);  // Recursive call for nested objects
        }

        return false;
    }

    for (let prop in obj) {
        if (obj.hasOwnProperty(prop) && isNotEmpty(obj[prop])) {
            return true;
        }
    }

    return false;
}

/**
 * Takes a value that could be a react element or a string,
 * and tells you if we consider it to be 'empty'.
 * @param itemValue
 * @returns {boolean}
 */
export const elementIsEmpty = (itemValue) => {
    // Is element a zero length string?
    if (typeof itemValue === 'string') {
        return !itemValue.length;
    }

    // Is it a jsx element?
    if (React.isValidElement(itemValue)) {
        // If it's a standard html element, it's considered empty if there are no children
        const isStandardHtmlElement = typeof itemValue.type === 'string';
        if (isStandardHtmlElement && !itemValue.props.children) {
            return true;
        }
    }

    return false;
}
